import { memo } from 'react';
import { useLocation } from 'react-router';
import { Stack, Typography, Button as MuiButton } from '@mui/material';
import { InlineBackdrop } from '@client/components/common/Backdrop';
import { openLoginModal } from '@client/components/Main/Login';
import { openSignupModal } from '@client/components/Main/Signup';
import { SignupIntents } from '@sda/enums';

export const LoggedOut = memo(() => {
  const location = useLocation();

  return (
    <InlineBackdrop color="success">
      <Stack spacing={3}>
        <div>
          <Typography
            variant="subtitle2"
            paragraph
          >
            Claim ticket(s)
          </Typography>

          <Typography color="textSecondary">
            Sign up or log in to claim your ticket(s).
          </Typography>
        </div>

        <Stack spacing={2}>
          <MuiButton
            id="sda-ticket-redeem-signup-button"
            color="success"
            variant="contained"
            size="large"
            onClick={() => openSignupModal({
              destination: location.pathname,
              intent: SignupIntents.AUDIENCE,
            })}
          >
            Sign up
          </MuiButton>

          <MuiButton
            id="sda-ticket-redeem-login-button"
            color="success"
            variant="outlined"
            size="large"
            onClick={() => openLoginModal({
              destination: location.pathname,
              intent: SignupIntents.AUDIENCE,
            })}
          >
            Log in
          </MuiButton>
        </Stack>
      </Stack>
    </InlineBackdrop>
  );
});
